import React, { useRef, useState, useEffect } from 'react';
import imageIcon from "media/icons/dls/image.svg";
import FileDropzone from 'components/common/FileDropzone';
import "./TableImageComponent.scoped.scss";
import CustomDropdown from 'components/common/CustomDropDown';
import { ImageScale } from 'interfaces/sw/SWInterfaces';

interface TableImageComponentProps {
    handleImageUpload: (url: string, file: File, imageScale : ImageScale) => void;
}

const TableImageComponent: React.FC<TableImageComponentProps> = ({ handleImageUpload }) => {
    const [openFileDropModal, setOpenFileDropModal] = useState(false)
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [addButtonDisabled, setAddButtonDisabled] = useState(true)
    const [previewSrc, setPreviewSrc] = useState<string | null>(null);
    const [selectedFile, setSelectedFile] = useState<File | undefined>(undefined);
    const [selectedScalingOption, setSelectedScallingOption] = useState<ImageScale>(ImageScale.Medium);

    const handleIconClick = () => {
        setOpenFileDropModal(true);
    };

    const onFileChosen: React.ChangeEventHandler<HTMLInputElement> = (event) => {
        if (!event.target.files?.length) {
            return;
        }

        handleFileChange(event.target.files[0]);
        event.target.value = "";
        event.target.files = null
    };

    const handleFileChange = (file: File) => {
        if (file && file.type.startsWith('image/')) {
            setSelectedFile(file);
            setAddButtonDisabled(false);
            setOpenFileDropModal(false)
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewSrc(reader.result as string);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleAccept = () => {
        if (selectedFile !== undefined) {
            const url = URL.createObjectURL(selectedFile);
            handleImageUpload(url, selectedFile, selectedScalingOption);
        }

        handleCancel();
    };

    const handleCancel = () => {
        setPreviewSrc(null);
        setSelectedFile(undefined);
        setOpenFileDropModal(false);
        setAddButtonDisabled(true);
    };

    const options = [
        ImageScale.Small,
        ImageScale.Medium,
        ImageScale.Large
    ];

    const handleSelect = (option: ImageScale ) => {
       setSelectedScallingOption(option);
    };


    return (
        <div>
            <button className="rdw-option-wrapper image-button" onClick={() => { handleIconClick() }}>
                <img
                    src={imageIcon}
                    title="Image"
                    className="icon-small"
                    alt='Button to upload an image.'
                />
            </button>

            {openFileDropModal &&
                <div className="drop-file-container">
                    <span className="drop-file-title">File Upload</span>
                    <br />
                    <FileDropzone onFilesDropped={([file]) => handleFileChange(file)}>
                        <button
                            className="secondary-button choose-image"
                            onClick={() => fileInputRef.current?.click()}
                        >
                            {"Drop the file or click to upload"}
                        </button>
                    </FileDropzone>
                    <br />
                    <button className="add-button" disabled={addButtonDisabled}>
                        Add
                    </button>
                    <button className="add-button" onClick={handleCancel}>
                        Cancel
                    </button>
                </div>
            }
            <input
                ref={fileInputRef}
                type="file"
                accept="image/gif, image/jpeg, image/jpg, image/png, image/svg+xml"
                style={{ display: 'none' }}
                onChange={onFileChosen}
            />
            {previewSrc && (
                <div className="preview-container">
                    <img
                        src={previewSrc}
                        style={{ maxWidth: '250px', display: 'block', marginBottom: '1rem' }}
                    />
                    <br />
                    <div className="action-row">
                        <CustomDropdown options={options} onSelect={handleSelect} currentValue={selectedScalingOption} />
                        <button className="add-button" disabled={addButtonDisabled} onClick={handleAccept}>
                            Add
                        </button>
                        <button className="add-button" onClick={handleCancel}>
                            Cancel
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TableImageComponent;